module.exports = __webpack_public_path__ + "assets/icon-clone-list.5c7ce6b2.svg";